<template>
  <div>
    <b-modal
      id="modal-report-verification"
      class="mc-modal"
      size="md"
      :title="$t('report.object.savedReport')"
    >
      <p>{{ messageModal }}</p>
      <template #modal-footer>
        <b-row class="modal__footer mx-0">
          <b-col sm="12" md="12" class="modal__footer-btn">
            <McButton
              variant="primary"
              :text="$t('report.object.backToReport')"
              @click="handleBack"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>
import McButton from '@/components/McButton'

export default {
  props: {
    domain: {
      type: String,
    },
    message: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    McButton,
  },
  data() {
    return {
      isSavedReportExist: false,
    }
  },
  mounted() {
    const savedReport = JSON.parse(localStorage.getItem('saveReports'))
    if (savedReport) {
      this.isSavedReportExist = savedReport.find((item) => item.key === this.$route.query.key)
      if (this.$route.query.key && (!this.isSavedReportExist || this.messageModal.length > 0))
        this.$bvModal.show('modal-report-verification')
    }
  },
  computed: {
    messageModal() {
      if (this.error && this.message === 'Access to this resource is prohibited') {
        return this.$t('report.text.vehicleNotFound')
      } else if (this.error) {
        return this.$t('report.text.filterReportInvalid')
      } else if (!this.isSavedReportExist) {
        return this.$t('report.text.savedReportNotExist')
      } else return ''
    },
  },
  methods: {
    handleBack() {
      this.$router.replace({ name: 'Report', query: { domain: this.domain } })
    },
  },
}
</script>
